class surveyResponseFormatter {
  static getFlattenResponse(items) {
    const len = items.length
    return items.map(item => {
      const question = item.survey_base_question.survey_base_question.localizationStrings[0].body
      const { answerType } = item.survey_base_question
      const response = {}
      /* We use mapping for pairing the Id's to the question / response */
      const questionMapping = item.survey_base_question.survey_base_question.id
      const responseMapping = {}
      const finalAnswer = null
      const { responseAllowance } = item
      /* Put sortOrder = `NULL` after values with sortOrder */
      const sortOrder = item.sortOrder || len + 1
      let type
      if (answerType === 'radioButton' || answerType === null) {
        item.survey_responses.map(answers => {
          const surveyResponse =
            answers.survey_base_response.survey_base_response.localizationStrings[0].body
          type = 'radioButton'
          return Object.assign(response, { [surveyResponse]: null })
        })

        item.survey_responses.map(answers => {
          const surveyResponse =
            answers.survey_base_response.survey_base_response.localizationStrings[0].body
          const baseResponseId = answers.survey_base_response.survey_base_response.id
          return Object.assign(responseMapping, { [surveyResponse]: baseResponseId })
        })
      }
      if (answerType === 'searchInput') {
        const retailerAnswers = []
        item.survey_responses.map(answers => {
          const { id, name } = answers.retailer
          type = 'searchInput'
          return retailerAnswers.push({ id, name })
        })
        Object.assign(response, { retailers: retailerAnswers })

        item.survey_responses.map(answers => {
          const { name } = answers.retailer
          const { id } = answers.retailer
          return Object.assign(responseMapping, { [name]: id })
        })
      }

      return {
        question,
        questionMapping,
        response,
        responseMapping,
        type,
        responseAllowance,
        sortOrder,
        finalAnswer,
      }
    })
  }
}

export default surveyResponseFormatter
